import * as actions from '../../actions/types';
import { combineReducers } from 'redux';

const tickets = (state = {}, action) => {
  switch (action.type) {
    case actions.CHECKOUT_TICKET_QTY_INCREASE:
      return Object.assign({}, state, getTicketQuantityUpdatedObject(state, action.ticket, 1));
    case actions.CHECKOUT_TICKET_QTY_DECREASE:
      return Object.assign({}, state, getTicketQuantityUpdatedObject(state, action.ticket, -1));
    case actions.CHECKOUT_ABANDON:
    case actions.CHECKOUT_INIT:
      return {};
    default:
      return state;
  }
};

const getTicketQuantityUpdatedObject = (state, ticket, quantity) => {
  const ticketId = ticket.id;
  let result = {};

  if (state[ticketId]) {
    result = Object.assign({}, state[ticketId]);
  } else {
    result = {qty: 0};
  }

  result.qty += quantity;

  if (result.qty < 0) {
    result.qty = 0;
  }

  if (result.qty > ticket.max) {
    result.qty = ticket.max;
  }

  return {
    [ticketId]: result
  };
};

const seats = (state = [], action) => {
  switch (action.type) {
    case actions.CHECKOUT_TICKET_SELECTION_SUCCESS:
    case actions.CHECKOUT_SEATS_SELECTION_SUCCESS:
      return action.data.seats;
    case actions.CHECKOUT_ABANDON:
    case actions.CHECKOUT_INIT:
      return [];
    default:
      return state;
  }
};

const candybar = (state = {}, action) => {
  switch (action.type) {
    case actions.CHECKOUT_CANDYBAR_ITEM_SAVE:
      return Object.assign({}, state, getItemAddedCandybarObject(state, action.item, action.unitId, action.config));
    case actions.CHECKOUT_CANDYBAR_ITEM_REMOVE:
      return removeItemAndGetCandybarObject(state, action.itemId, action.unitId);
    case actions.CHECKOUT_ABANDON:
    case actions.CHECKOUT_INIT:
      return {};
    default:
      return state;
  }
};

const getItemAddedCandybarObject = (state, item, unitId, config) => {
  let selection;

  if (item.id in state) {
    selection = Object.assign({}, state[item.id]);
  } else {
    selection = {};
  }

  selection[unitId] = {
    id: unitId,
    config
  };

  return {[item.id]: selection};
};

const removeItemAndGetCandybarObject = (state, itemId, unitId) => {
  const result = Object.assign({}, state);

  if (Object.keys(result[itemId]).length > 1) {
    delete result[itemId][unitId];
  } else {
    delete result[itemId];
  }

  return result;
};

const transactionId = (state = null, action) => {
  switch (action.type) {
    case actions.CHECKOUT_TICKET_SELECTION_SUCCESS:
      return action.data.transaction_id;
    case actions.CHECKOUT_ABANDON:
    case actions.CHECKOUT_INIT:
      return null;
    default:
      return state;
  }
};

export default combineReducers({
  tickets,
  candybar,
  seats,
  transactionId,
});
